import { FETCH_ROLE_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  selectList: [],
  others: {},
};

const roleListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLE_LIST:
      return {
        list: action.payload,
        selectList: action.payload,
        others: action.others,
      };
    default:
      return state;
  }
};

export default roleListReducer;
